/* eslint-disable no-console */
function setApi(apiMap: unknown) {
  localStorage.setItem('api', JSON.stringify(apiMap))
}

function getApi() {
  return JSON.parse(localStorage.getItem('api') ?? 'null')
}

function setUser(userData: unknown) {
  localStorage.setItem('user', JSON.stringify(userData))
}

function getUser() {
  return JSON.parse(localStorage.getItem('user') ?? 'null')
}

function removeUser() {
  localStorage.removeItem('user')
}

function setHasALogin() {
  localStorage.setItem('hasALogin', JSON.stringify({ hasALogin: true }))
}

function getHasALogin() {
  return localStorage.getItem('hasALogin')
}

function log(callingModule: string) {
  console.debug(
    `${callingModule} -> [services/StorageService.ts] | LocalStorage:`
  )
  console.debug(localStorage)
}

export default {
  setApi,
  getApi,
  setUser,
  getUser,
  removeUser,
  setHasALogin,
  getHasALogin,
  log,
}
